import {ServiceTemplateGeneric} from "./ServiceTemplateGeneric";

export class ServiceTemplateEmail extends ServiceTemplateGeneric{

    constructor(organizationId,data) {
        super(organizationId,data,"serviceEmailList","serviceEmailId");
    }
}
